import { AbstractControl, ValidatorFn } from "@angular/forms";

export class CustomValidators {
  /** 空白を除去した上での必須チェックを行う */
  static requiredTrimmed(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value !== 0 && !control.value) {
        return { required: "false" };
      }
      const validate = String(control.value).trim();
      return validate.length > 0 ? null : { required: "false" };
    };
  }

  static specifiedCharacterLength(specifiedLengths: number[]): ValidatorFn {
    const errorObj = { specifiedCharacterLength: "false" };

    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value !== 0 && !control.value) {
        return errorObj;
      }

      return specifiedLengths.some((length) => length === control.value?.length) ? null : errorObj;
    };
  }
}
